import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-document',
  templateUrl: './view-document.component.html'
})
export class ViewDocumentComponent implements OnInit {

  dialogTitle = '';
  formSrc: any;

  constructor(private matDialogRef: MatDialogRef<ViewDocumentComponent>) { }

  ngOnInit(): void {
  }

  closeClick() {
    this.matDialogRef.close();
  }
}
